<template>
  <div>
    <b-form @submit="onSaveDocument">
      <div class="box box-primary">
        <div class="box-header">
          <h3 class="box-title">{{$t('documentation.title')}}</h3>
        </div>
        <div class="box-body">
          <div class="row">
            <!-- row start -->
            <div class="col-md-12">
              <div class="form-group">
                <label for="manager">{{$t('documentation.name')}}</label>
                <input
                  v-model="documentData.name"
                  type="text"
                  class="form-control"
                  :placeholder="$t('documentation.name')"
                />
              </div>
            </div>
            
          </div>
          <!-- row end -->

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="description">{{$t('documentation.url')}}</label>
                <!-- <input
                  v-if="config == false"
                  type="text"
                  class="form-control"
                  v-model="documentData.url"
                  :placeholder="$t('documentation.url')"
                /> -->
                 <input
                  type="file"
                  id="files"
                  name="attachment"
                  ref="files"
                  multiple
                  v-on:change="handleFilesUpload()"
                  value="Upload"
                />

              </div>
            </div>
          </div>
        </div>
        <b-button
          ref="formsubmitbutton"
          type="submit"
          variant="primary"
          style="display: none;"
        >{{$t('common.submit')}}</b-button>
      </div>
    </b-form>
    <!-- /.box-body -->
    <div class="box-footer">
      <button
        type="button"
        class="btn btn-labeled btn-danger"
        @click="onCancel"
        style="margin: 0px; background-color: #f29911; border-color: #f29911;"
      >
        <span class="btn-label">
          <i class="fa fa-mail-reply"></i>
        </span>
        {{$t('common.back')}}
      </button>

      <button        
        type="button"
        class="btn btn-labeled btn-success pull-right"
        @click="onSave"
        style="margin: 0px;"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
        </span>
        {{$t('common.save')}}
      </button>
    </div>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <router-view></router-view>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// import SelectOptionCustom from "@/components/SelectOptionCustom.vue";
// import datePicker from "vue-bootstrap-datetimepicker";
// import moment from "moment";
import constantData from '@/lib/constantsData';
import { uploadFileToMediaAgent } from '@/lib/utils'

export default {
  name: "DocumentationAdd",
  props: {
    agenda_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    callback: {
      type: String
    }
  },
  data() {
    return {
      timeCurrent: "2019-01-16T06:00:00Z",
      documentData: {
        id: 0,
        name: "",
        url: "",
        project: null,

      },
      file_upload: null,
      file_name: undefined,
      base64: null,
      modal_title: "",
    };
  },

  watch: {
    GET_DOCUMENT_DETAIL_DATA:function(){
      this.documentData.id=this.GET_DOCUMENT_DETAIL_DATA.id
      this.documentData.name=this.GET_DOCUMENT_DETAIL_DATA.name;
      this.documentData.url=this.GET_DOCUMENT_DETAIL_DATA.url;
      this.documentData.project=this.GET_DOCUMENT_DETAIL_DATA.project_id
    }
  },

  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_DOCUMENT_DETAIL_DATA"
    ]),

    role: function() {
      return this.GET_ACCOUNT_DATA.id;
    }
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_DOCUMENT_DETAIL",
      "ADD_DOCUMENT",
      "UPDATE_DOCUMENT",
    ]),
    handleFilesUpload: async function(){
      if(this.$refs.files.files[0].size > constantData.emailConfigure.size)
      {
        this.ON_SHOW_TOAST({
          message:
            "Tập tin không vượt quá " +
            constantData.emailConfigure.max_file_size.text,
          styleType: "danger"
        });
        return;
      }
      this.file_upload = this.$refs.files.files[0]
      this.file_name = this.$refs.files.files[0].name
      this.documentData.url = await uploadFileToMediaAgent(this.file_upload, "documents")
    },
    callBackToList: function() {
      let name = "Documentation";
      if (typeof this.callback !== "undefined") {
        name = this.callback;
      }
      this.$router.push({
        name: name
      });
    },
    onCancel: function() {
      this.callBackToList();
    },
    validateData: function() {
      let validatedResult = "OK";

      for (let key in this.documentData) {
        if (key == "project") {
          //
        } else if (
          this.documentData[key] === null ||
          this.documentData[key] === ""
        ) {
          validatedResult =
            "Xin vui lòng nhập " + this.$t("documentation." + key);
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    /**
     * Save and Update Document
     */
    onSaveDocument: function(event) {
      event.preventDefault();
      let result = this.validateData();
      if(result=="OK") 
      {
        let data = {
          name: this.documentData.name,
          url: this.documentData.url
        };
        if (parseInt(this.documentData.id) == 0) {
          this.ADD_DOCUMENT(data)
            .then(
              function(res) {
                this.SUCCESS_TOAST();
                this.callBackToList();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_DOCUMENT({id: this.documentData.id, data})
            .then(
              function(res) {
                this.callBackToList();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }else  {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },

    onSave() {
      this.$refs.formsubmitbutton.click();
    },

    // showInformmodal: function(title) {
    //   this.modal_title = title;
    //   $("#inform_modal").modal("show");
    // },
  },

  mounted(){
    let id = this.$route.params.id;
    if(id!=0)
      this.GET_DOCUMENT_DETAIL({id: id})
  },
  created() {

  },

  components: {
    "lte-core-alert": LTECoreAlert
    // "date-picker": datePicker
    // "select-option-custom": SelectOptionCustom
  }
};
</script>

<style lang="" scoped>
@media (min-width: 768px) {
  .modal-dialog {
    width: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Documentation/DocumentationAdd.vue